import React, { useMemo } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCog } from "@fortawesome/pro-light-svg-icons";

import MenuDropdown from "components/nav/MenuDropdown/MenuDropdown";
import MenuTrigger from "components/nav/MenuTrigger/MenuTrigger";
import Text from "components/common/Text/Text";

const menuItems = [
	{
		id: "managers",
		displayName: "User Roles",
		pathName: "/admin/roles",
	},
];

const NavManage: React.FC = () => {
	const overlay = useMemo(
		() => ({
			tooltipReference: (
				<MenuTrigger>
					<Text inline={true}>Manage</Text>
				</MenuTrigger>
			),
		}),
		[],
	);

	return (
		<MenuDropdown
			referenceClassName={"Navigation__manage"}
			items={menuItems}
			tooltipClassName={"Navigation__manage-menu"}
			placement={"bottom-end"}
			overlay={overlay}
		>
			<FontAwesomeIcon icon={faCog} className={"navigation-manage"} />
		</MenuDropdown>
	);
};

export default NavManage;
